import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import DeleteButton from '../../shared/DeleteButton.js';
import './DeathCauseCardList.css';

const systemAccount = "000000000000000000000000";

const DeathCauseCard = ({ row, onDeleted }) => {
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState(false);
  const isSystem = row.account === systemAccount;

  return (
    <div className={`death-cause-card ${expanded ? 'expanded' : ''}`} onClick={() => setExpanded(e => !e)}>
      <div className="death-cause-card-main">
        <div className="death-cause-card-name">{t(row.name, { defaultValue: row.name }) || '—'}</div>
        <div className={`death-cause-card-type ${isSystem ? 'system' : 'custom'}`}>
          {isSystem ? t('breed_type_system') : t('breed_type_custom')}
        </div>
        <div className="death-cause-card-chevron">{expanded ? '▲' : '▼'}</div>
      </div>

      {expanded && (
        <div className="death-cause-card-detail" onClick={e => e.stopPropagation()}>
          {row.matches && (
            <div className="death-cause-card-detail-row">
              <span>{t('nicknames')}</span><span>{row.matches}</span>
            </div>
          )}
          {!isSystem && (
            <div className="death-cause-card-actions">
              <DeleteButton
                collection="death_causes"
                data={[row]}
                onComplete={onDeleted}
                onError={() => {}}
              />
            </div>
          )}
          {isSystem && (
            <div className="death-cause-card-system-note">{t('system_record_no_delete')}</div>
          )}
        </div>
      )}
    </div>
  );
};

const DeathCauseCardList = ({ data, onRefresh }) => {
  return (
    <div className="death-cause-card-list">
      {data && data.map(row => (
        <DeathCauseCard key={row._id} row={row} onDeleted={onRefresh} />
      ))}
      {(!data || data.length === 0) && (
        <div className="death-cause-card-empty">—</div>
      )}
    </div>
  );
};

export default DeathCauseCardList;
